/** @format */

import moment from 'moment';
import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotifications } from 'stateContainer/actions';

export default function Notifications({
  text: { heading },
  propertyTypeTranslation,
  notificationStatusTranslation,
  displayHeading = true
}) {
  const {
    notifications: { data, isFetching }
  } = useSelector((state) => state);

  const {
    data: { userData }
  } = useSelector((state) => state.session);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isFetching && userData && userData.brokerId) {
      dispatch(fetchNotifications(userData.brokerId));
    }
  }, []);

  const getNotificationMessage = (notification) => {
    let statusString = '';
    let categoryString = '';

    if (notification.status) {
      statusString = `${notificationStatusTranslation.to} ${
        notificationStatusTranslation.status[notification.status]
      }`;
    }

    let eventString = notificationStatusTranslation.delete;

    if (notification.event === 'Update') {
      eventString = notificationStatusTranslation.update;
    }

    if (notification.category.trim() === 'User') {
      categoryString = 'Användare';
    } else {
      categoryString = propertyTypeTranslation[notification.category];
    }

    return `${categoryString} ${notification.id} ${eventString} ${statusString}`;
  };

  return (
    <div className='dashboard-notifications-body-section'>
      {displayHeading && (
        <div className='dashboard-main-heading'>
          <h2>{heading}</h2>
        </div>
      )}
      {isFetching && (
        <div className='dashboard-notifications-loading-container'>
          <Spinner
            animation='border'
            role='status'
            style={{ color: 'var(--color-primary-pink)' }}
          />
        </div>
      )}
      {data.length === 0 ? (
        <div className='dashboard-notifications-loading-container'>
          <p className='text1r'>No notifications yet</p>
        </div>
      ) : (
        data.map((notification, index) => (
          <div className='dashboard-notification-bar' key={index}>
            <p className='text3r'>
              {moment(notification.createdDatetime).format('MM/DD/YYYY')}
            </p>
            <div className='dashboard-notification-text'>
              <p className='text1r'>{getNotificationMessage(notification)}</p>
            </div>
            <p className='text4r'>
              {moment(notification.createdDatetime).format('hh:mm A')}
            </p>
          </div>
        ))
      )}
    </div>
  );
}
